// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Member from '../_raw/ui/icon_member.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Member);
